import { useLocation } from "wouter";
import { Mail, LogIn, KeyRound, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface EmailExistsProps {
  email: string;
}

export default function EmailExistsPage({ email }: EmailExistsProps) {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center">
            <Mail className="w-10 h-10 text-blue-600 dark:text-blue-400" />
          </div>
          <CardTitle className="text-2xl">Účet už existuje</CardTitle>
          <CardDescription className="text-base">
            Email <strong>{email}</strong> je už registrovaný v našom systéme.
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <div className="space-y-3">
            <Button
              onClick={() => setLocation("/auth")}
              className="w-full"
              size="lg"
            >
              <LogIn className="w-4 h-4 mr-2" />
              Prihlásiť sa
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            
            <Button
              onClick={() => setLocation("/auth?forgot-password=true")}
              variant="outline"
              className="w-full"
              size="lg"
            >
              <KeyRound className="w-4 h-4 mr-2" />
              Zabudli ste heslo?
            </Button>
          </div>

          <div className="text-center text-sm text-muted-foreground pt-4 border-t">
            <p>
              Potrebujete pomoc?{" "}
              <a href="mailto:support@taskkrow.click" className="text-primary hover:underline">
                Kontaktujte podporu
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
